import { Flex, Typography } from "antd";
import React from "react";
import PDFPageIcon from "../../images/PDFPageIcon.svg";
import { SvgIcons } from "Icon/SvgIcons";
import { useAppSelector } from "hooks/reduxHooks";

const { Text } = Typography;

interface Document {
  name?: string;
  size?: string | number;
  url?: string;
  type?: string;
  id: string;
  noteId: string | number;
  userId: string | number;
  // Add any other document properties you need
}

interface FIlesWithNameProps {
  document: Document;
  handleDelete?: any;
  handleEdit?: any;
}

const FIlesWithName: React.FC<FIlesWithNameProps> = ({ document, handleDelete, handleEdit }) => {
  const userData = useAppSelector((state: any) => state.user.user);
  return (
    <Flex justify="space-between" align="center" className="mb-2" style={{ cursor: "pointer" }}>
      <a
        href={document?.url}
        target="_blank"
        rel="noopener noreferrer"
        className="cursor-pointer"
        style={{ display: "flex", alignItems: "center", flexGrow: 1 }}
      >
        <img src={PDFPageIcon} alt="PDF Icon" style={{ width: 40 }} />
        <Flex vertical className="mt-2 mx-2">
          <Text className="block">{document?.name}</Text>
          <Text type="secondary" style={{ fontSize: "12px" }}>
            {typeof document?.size === "number"
              ? `${(document.size / 1024).toFixed(2)} KB`
              : document?.size}
          </Text>
        </Flex>
      </a>
      {document?.userId === userData?.id && (
        <Flex align="center" gap={12}>
          {/* <span className="cursor-pointer" onClick={handleEdit}>{SvgIcons.pencileSvg}</span> */}
          {handleDelete && (
            <span className="text-red-500 cursor-pointer" onClick={handleDelete}>
              {SvgIcons.trashSvgIcon}
            </span>
          )}
        </Flex>
      )}
    </Flex>
  );
};

export default FIlesWithName;
